export default theme => ({
  fullWidth: {
    width: '100%'
  }
});
